module.exports = __webpack_public_path__ + "static/media/fax.66e9f6f1.svg";